module.exports = __webpack_public_path__ + "img/130.5f5f3864.jpg";